module.exports = __webpack_public_path__ + "img/vip-roulette.01922b67.png";